import {
  Component,
  EventEmitter,
  Output,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { DeliveryAddress } from 'src/app/api/models/statistics';
import {
  CheckoutLineModel,
  CheckoutOrderModel,
  CheckoutOrderResponseModel,
  CartProductModel,
  BonusProductInfo,
  CheckoutViewModel,
} from 'src/app/api/models/checkout';
import { SnackBarService } from 'src/app/api/services/snack-bar.service';
import { CheckoutService } from 'src/app/api/services/checkout.service';
import { CartService } from 'src/app/api/services/cart.service';
import { MatDialog } from '@angular/material/dialog';
import { CheckoutDialogComponent } from 'src/app/Custom/checkout-dialog/checkout-dialog.component';
import { Cliente, ProfileDataRequest } from 'src/app/api/models/perfil';
import { PerfilService } from 'src/app/api/services/perfil.service';
import { Subscription } from 'rxjs';
import { EncomendasService } from 'src/app/encomendas/encomendas.service';
import {
  PendingOrders,
  PendingOrdersRequest,
} from 'src/app/encomendas/encomendas.model';
import { GenericModalComponent } from 'src/app/Custom/generic-modal/generic-modal.component';
import { environment } from 'src/environments/environment';
import { EncryptionService } from 'src/app/api/services/encryption.service';
import { StorageKeys } from 'src/app/api/models/storageKeys';
import { PointsService } from 'src/app/api/services/points.service';
import { AuthService } from 'src/app/api/services';
import { QuantityCampaignDetails, ShopItemModel } from 'src/app/api/models/shop-item.model';
import { DialogData, ProductBonusModalComponent } from 'src/app/Custom/product-bonus-modal/product-bonus-modal.component';
import { CheckoutProductsCampaignsComponent } from 'src/app/Custom/checkout-products-campaigns/checkout-products-campaigns.component';

@Component({
    selector: 'app-checkout',
    templateUrl: './checkout.component.html',
    styleUrls: ['./checkout.component.css'],
    standalone: false
})
export class CheckoutComponent implements OnInit, OnDestroy {
  information: string = `${environment.information}`;
  iban: string = `${environment.ibaninfo}`;
  comprovativo: string = `${environment.comprovativo}`;
  user!: ProfileDataRequest;
  isLoading: boolean = true;
  checkoutViewModel!: CheckoutViewModel;
  profileRequest: ProfileDataRequest = this.perfilService.getCurrentUserInfo();
  checkoutLines: CheckoutLineModel[];
  deliveryAddressList: DeliveryAddress[];
  selectedAddress: DeliveryAddress = {
    deliveryAddressId: '',
    clientAddressCode: '',
    address: '',
    zipCodeDesignation: '',
    locality: '',
    zipCodeCP4: '',
    zipCodeCP3: '',
    clientId: '',
    isPreferedAddress: false
  };
  isMasterUser: boolean;
  observations: string;
  orderTotal: number;
  orderPointsTotal: number;
  defaultAddress: string = '';
  checkoutLineToRemove?: CheckoutLineModel;
  changingCheckbox: boolean = false;
  normalCurrencyCheckoutLines: CheckoutLineModel[] = [];
  pointsProductCheckoutLines: CheckoutLineModel[] = [];
  bonusProductCheckoutLines: BonusProductInfo[] = [];
  isCheckoutComplete: boolean = false;
  anySuccess: boolean = false;
  regularOrderSuccess: boolean = false;
  pointsOrderSuccess: boolean = false;
  sggOrderNumber: string = '000000';
  unsubscribe: Subscription = new Subscription();
  moradaDefeito = this.encrypt.getDecryptedItem(
    StorageKeys.BIO2_CLIENT_ADDRESS_ID
  );
  adresses: DeliveryAddress[] = [];
  existsInDb: boolean = false;
  private subscription!: Subscription;
  isReadingPoints: boolean = true;
  pointsSubscription!: Subscription;
  points!: number;
  storageAdresseChanged!: DeliveryAddress;
  referenciaDuplicada: string = '';
  duplicated: boolean = false;

  @Output() isCampaignModalOpen = new EventEmitter<boolean>();

  loggedUser: ProfileDataRequest = this.perfilService.getCurrentUserInfo();
  userData!: Cliente;

  hasSuperClient: boolean = false;
  checkoutViewModelProcessed: boolean = false;

  constructor(
    private perfilService: PerfilService,
    private checkoutService: CheckoutService,
    private snackBarService: SnackBarService,
    public dialog: MatDialog,
    private encomendaService: EncomendasService,
    public cartService: CartService,
    private cdr: ChangeDetectorRef,
    private encrypt: EncryptionService,
    public pointsService: PointsService,
    public authService: AuthService
  ) {
    this.deliveryAddressList = [];
    this.checkoutLines = [];
    this.isMasterUser = false;
    this.observations = '';
    this.orderTotal = 0;
    this.orderPointsTotal = 0;
  }

  ngOnInit(): void {
    const decryptedAddressesChanged = this.encrypt.getDecryptedItem(StorageKeys.BIO2_SELECTED_CHANGED_ADDRESS);
    this.user = this.perfilService.getCurrentUserInfo();
    if (decryptedAddressesChanged) {
      this.storageAdresseChanged = JSON.parse(decryptedAddressesChanged);
      if (this.storageAdresseChanged !== this.selectedAddress) {
        this.selectedAddress = this.storageAdresseChanged;
      }
    }

    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      let fullKey = this.user.userId + '_' + this.user.clientId + '_' + 'observations'
      if (key! === fullKey) {
        let decriptedObservations = this.encrypt.decrypt(sessionStorage.getItem(key)!);
        this.observations = decriptedObservations!;
        break
      }
    }

    this.subscription = this.pointsService.isReadingPoints$.subscribe(
      value => {
        this.isReadingPoints = value;
      }
    );
    this.pointsSubscription = this.pointsService.readPoints$.subscribe(
      points => {
        this.points = points;
      }
    );

    this.getUserDetails();
    this.GetCheckoutViewModel(this.profileRequest.clientId);

    this.isSubClient();

    this.fetchUserCheckoutObservation();
  }

  onKeyDown(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const currentValue = input.value;
    if (+currentValue >= 1000 && !this.isControlKey(event)) {
      event.preventDefault();
    }
  }

  isControlKey(event: KeyboardEvent): boolean {
    const controlKeys = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Backspace', 'Delete', 'Tab'];
    return controlKeys.includes(event.key);
  }

  compareFamilyObjects(f1: any, f2: any): boolean {
    return f1 && f2 ? f1.address === f2.address && f1.clientAddressCode === f2.clientAddressCode : f1 === f2;
  }

  GetCheckoutViewModel(sessionClientNumber: string): void {
    this.checkoutViewModelProcessed=false;
    this.unsubscribe.add(
      this.checkoutService.GetCheckoutViewModel(sessionClientNumber).subscribe(
        (response) => {
          this.checkoutViewModel = response;
          this.deliveryAddressList = this.checkoutViewModel.addressLists;

          this.checkoutLines = this.checkoutViewModel.checkoutLines;

          // Store previous point flag to check if the user changed the use points flag
          this.checkoutLines.forEach((element) => {
            element.previousPointFlag = element.usePoints;
          });

          // Set the checkout lines to the correct arrays
          this.normalCurrencyCheckoutLines = this.checkoutLines.filter(
            (line) => !line.usePoints
          );
          this.pointsProductCheckoutLines = this.checkoutLines.filter(
            (line) => line.usePoints
          );

          this.isMasterUser = this.checkoutViewModel.isMasterUser;

          let moradaDefeitoAddress = this.deliveryAddressList.find(address => {
            return address.deliveryAddressId == this.moradaDefeito;
          });

          if (!moradaDefeitoAddress) {
            moradaDefeitoAddress = this.deliveryAddressList[0];
          }

          if (this.selectedAddress.clientAddressCode == "") {

            this.selectedAddress = moradaDefeitoAddress!;
            this.defaultAddress =
              this.checkoutViewModel.userDefaultAddress;
          }
          else {
            this.selectedAddress = this.storageAdresseChanged;
          }

          const sessionCart = this.cartService.getSessionCart();
          if (Array.isArray(sessionCart) && sessionCart.length > 0) {
            this.normalCurrencyCheckoutLines.forEach((line) => {
              const cartProduct = sessionCart.find(
                (p) => p.productId === line.referencia && p.usePoints === false
              );
              if (cartProduct) {
                line.labFlashDiscount = cartProduct.labFlashDiscount ?? 0;
                line.labFlashBonus = cartProduct.labFlashBonus ?? 0;
              }
              else{
                line.labFlashDiscount = 0;
                line.labFlashBonus = 0;
              }
            });

            // Adding products to offer to checkout lines from sessionCart products with labFlashBonus > 0 and qtd == 0
            const missingCartProducts = sessionCart.filter(
              (cartProd) =>
                !this.normalCurrencyCheckoutLines.some(
                  (line) => line.referencia === cartProd.productId
                ) &&
                cartProd.usePoints === false &&
                (cartProd.labFlashBonus ?? 0) > 0
            );

            missingCartProducts.forEach((cartProd) => {
              const newLine = this.CreateCheckoutLineFromCartProduct(cartProd);
              this.normalCurrencyCheckoutLines.push(newLine);
            });
          }
          else{
            this.normalCurrencyCheckoutLines.forEach((line) => {
                line.labFlashDiscount = 0;
                line.labFlashBonus = 0;
            });
          }

          this.UpdateOrderTotals();
          this.pointsProductCheckoutLines.forEach((x) =>
            this.CheckAndUpdateBonusQuantity(x)
          );
          this.normalCurrencyCheckoutLines.forEach((x) =>
            this.CheckAndUpdateBonusQuantity(x)
          );

          this.isLoading = false;   
          this.checkoutViewModelProcessed=true;
        },
        (error) => {
          console.error('Error:', error);
          this.isLoading = false;
          this.checkoutViewModelProcessed=true;
        }
      )
    );
  }

 //Helper method to map CartProductModel to CheckoutLineModel
  private CreateCheckoutLineFromCartProduct(cartProd: CartProductModel): CheckoutLineModel {
    return {
      referencia: cartProd.productId,
      memoria: cartProd.memoria!,
      iva: 0,
      stock: 0,
      stock_Minimo: 0,
      marca_Laboratorio: "",
      grupo: "",
      dispensa: "",
      atc: "",
      armazenamento_Produto: "",
      imagem: "",
      familia: "",
      bula: "",
      pontos: 0,
      color: "",
      valor: cartProd.valor!,
      valor_Liquido: 0,
      produtoBonus: "",
      paraBonus: "",
      qtd: cartProd.quantity,
      usePoints: false,
      bonusProductInfo: cartProd.bonusProductInfo!,
      previousPointFlag: cartProd.usePoints,
      labFlashDiscount: cartProd.labFlashDiscount ?? 0,
      labFlashBonus: cartProd.labFlashBonus ?? 0,
      quantityCampaign: cartProd.quantityCampaign,
      discountPercentage: cartProd.discountPercentage,
      labDiscount: cartProd.labDiscount,
      otherDiscount: cartProd.otherDiscount,
    };
  }

  // Check duplicated Lines
  checkForDuplicateLines() {
    this.duplicated = false;
    const seenReferences = new Set<string>();
    for (const line of this.checkoutLines) {
      if (seenReferences.has(line.referencia)) {
        this.referenciaDuplicada = line.referencia;
        this.duplicated = true;
        break;
      } else {
        seenReferences.add(line.referencia);
      }
    }
  }

  // Increases or Removes the quantity of the product
  AddOrRemoveLineQuantity(
    line: CheckoutLineModel,
    op: string,
    newValue: string,
    confirmedOperation?:boolean
  ) {
    const oldLineQuantity = line.qtd;
    let numericValue = parseInt(newValue);
    if (op === 'add') {
      if (
        line.usePoints &&
        this.points - line.pontos < 0
      ) {
        this.snackBarService.openSnackBar(
          'Quantidade de pontos insuficiente',
          '#F97066',
          '../../../../assets/Icons/ErrorIcon.png'
        );
        return;
      }
      line.qtd++;
    }
    if (op === 'remove') {
      if(this.user.role === 'Laboratorio'){
        if (line.qtd - 1 < 0) {
          this.OpenDeleteConfirmationModal(line);
          return;
        } else {
          line.qtd--;
        }
      }else{
        if (line.qtd - 1 <= 0) {
          this.OpenDeleteConfirmationModal(line);
          return;
        } else {
          line.qtd--;
        }
      }
    }
    if (op === 'update') {
      if(this.user.role === 'Laboratorio'){
        if (numericValue < 0) {
          if(!confirmedOperation){
            this.OpenDeleteConfirmationModal(line);
            return;
          }
          else
            this.RemoveLine(line);
        } else {
          if (numericValue === line.qtd || isNaN(numericValue)) {
            line.qtd = NaN;
            this.cdr.detectChanges();
            line.qtd = oldLineQuantity;
            return;
          }
          if (
            line.usePoints &&
            this.points +
            line.qtd * line.pontos -
            numericValue * line.pontos <
            0
          ) {
            line.qtd = NaN;
            this.cdr.detectChanges();
            line.qtd = oldLineQuantity;
            this.snackBarService.openSnackBar(
              'Quantidade de pontos insuficiente',
              '#F97066',
              '../../../../assets/Icons/ErrorIcon.png'
            );
            return;
          }
          line.qtd = numericValue;
        }
      }else{
        if (numericValue == 0) {
          if(!confirmedOperation){
            this.OpenDeleteConfirmationModal(line);
            return;
          }
          else
            this.RemoveLine(line);
        } else {
          if (numericValue === line.qtd || isNaN(numericValue)) {
            line.qtd = NaN;
            this.cdr.detectChanges();
            line.qtd = oldLineQuantity;
            return;
          }
          if (
            line.usePoints &&
            this.points +
            line.qtd * line.pontos -
            numericValue * line.pontos <
            0
          ) {
            line.qtd = NaN;
            this.cdr.detectChanges();
            line.qtd = oldLineQuantity;
            this.snackBarService.openSnackBar(
              'Quantidade de pontos insuficiente',
              '#F97066',
              '../../../../assets/Icons/ErrorIcon.png'
            );
            return;
          }
          line.qtd = numericValue;
        }
      }    
    }

    let cartProduct: CartProductModel = {
      userId: '',
      clientId: this.profileRequest.clientId,
      productId: line.referencia,
      quantity: line.qtd,
      previouslyUsingPoints: line.previousPointFlag,
      usePoints: line.usePoints,
      points: line.pontos,
    };

    // Updates the quantity of the product on the backend
    this.unsubscribe.add(
      this.cartService
        .updateProduct(cartProduct)
        .subscribe((opResult: boolean) => {
          if (!opResult) {
            this.snackBarService.openSnackBar(
              'Ocorreu um erro, por favor tente mais tarde',
              '#F97066',
              '../../../assets/Icons/ErrorIcon.png'
            );
          }
        })
    );

    if (line.usePoints) {
      this.cartService.updateUserPoints(
        op,
        line.pontos,
        oldLineQuantity,
        numericValue
      );
    }
    this.UpdateOrderTotals();
    if (line.bonusProductInfo != null) this.CheckAndUpdateBonusQuantity(line);
  }

  // FUNCTION : Removes the line from the order
  RemoveLine(line: CheckoutLineModel): void {
    const usesPoints = line.usePoints;
    const cartLines = usesPoints
      ? this.pointsProductCheckoutLines
      : this.normalCurrencyCheckoutLines;

    const index = cartLines.indexOf(line);

    const checkoutIndex = this.checkoutLines.indexOf(line);
    this.checkoutLines.splice(checkoutIndex, 1)

    if (index === -1) {
      return; // Line not found, nothing to do
    }

    const cartProduct: CartProductModel = {
      userId: '',
      clientId: this.profileRequest.clientId,
      productId: line.referencia,
      quantity: 0,
      previouslyUsingPoints: line.previousPointFlag,
      usePoints: line.usePoints,
      points: line.pontos,
    };

    this.unsubscribe.add(
      this.cartService
        .updateProduct(cartProduct)
        .subscribe((opResult: boolean) => {
          if (opResult) {
            this.snackBarService.openSnackBar(
              'Linha removida com sucesso',
              '#12B76A',
              '../../assets/Icons/correct.png'
            );

            cartLines.splice(index, 1);
            this.CheckAndUpdateBonusQuantity(line);
            this.UpdateOrderTotals();
            if (line.usePoints === true) {
              this.cartService.updateUserPoints(
                'update',
                line.pontos,
                line.qtd,
                0
              );
            }
          } else {
            this.snackBarService.openSnackBar(
              'Ocorreu um erro, por favor tente mais tarde',
              '#F97066',
              '../../../assets/Icons/ErrorIcon.png'
            );
          }
        })
    );

    // Remove from session cart if exists
    const sessionCart = this.cartService.getSessionCart();
    if (Array.isArray(sessionCart)) {
      const sessionIndex = sessionCart.findIndex(
        (p) => p.productId === line.referencia && p.usePoints === line.usePoints
      );
      if (sessionIndex !== -1) {
        sessionCart.splice(sessionIndex, 1);
        this.cartService.updateCartSessionStorage(sessionCart); 
      }
    }

    // this.GetCheckoutViewModel(this.profileRequest.clientId);
    
  }

  // Function responsible for updating the use points flag on the backend
  // This also merge entries together if necessary
  SignalToUsePoints(line: CheckoutLineModel): void {
    this.changingCheckbox = true;

    let cartProduct: CartProductModel = {
      userId: '',
      clientId: this.profileRequest.clientId,
      productId: line.referencia,
      quantity: line.qtd,
      previouslyUsingPoints: line.previousPointFlag,
      usePoints: line.usePoints,
      points: line.pontos,
    };

    // Updates the quantity of the product on the backend
    this.unsubscribe.add(
      this.cartService
        .productPointsSwitcher(cartProduct)
        .subscribe((opResult: boolean) => {
          if (!opResult) {
            this.snackBarService.openSnackBar(
              'Ocorreu um erro, por favor tente mais tarde',
              '#F97066',
              '../../../assets/Icons/ErrorIcon.png'
            );
            line.usePoints = line.previousPointFlag;
            this.changingCheckbox = false;
          } else {
            line.previousPointFlag = line.usePoints;
            const targetLines = line.usePoints
              ? this.pointsProductCheckoutLines
              : this.normalCurrencyCheckoutLines;
            const otherLines = line.usePoints
              ? this.normalCurrencyCheckoutLines
              : this.pointsProductCheckoutLines;

            const index = targetLines.findIndex(
              (x) => x.referencia === line.referencia
            );
            if (index !== -1) {
              targetLines[index].qtd += line.qtd;
            } else {
              targetLines.push(line);
            }

            otherLines.splice(
              otherLines.findIndex((x) => x.referencia === line.referencia),
              1
            );

            this.UpdateOrderTotals();
            if (line.usePoints) {
              this.cartService.updateUserPoints('add', line.pontos * line.qtd);
            } else {
              this.cartService.updateUserPoints(
                'remove',
                line.pontos * line.qtd
              );
            }
            this.changingCheckbox = false;
          }
        })
    );
  }

  async BeginCheckout(): Promise<void> {
    this.isModalOpen = false;
    if (
      this.normalCurrencyCheckoutLines.length == 0 &&
      this.pointsProductCheckoutLines.length == 0
    ) {
      this.snackBarService.openSnackBar(
        'Não tem produtos no carrinho',
        '#F97066',
        '../../../assets/Icons/ErrorIcon.png'
      );
      return;
    }
    if (this.changingCheckbox == true) {
      // Checks if the user has enough points to complete the order
      if (this.orderPointsTotal > this.points) {
        this.snackBarService.openSnackBar(
          'Sem pontos suficientes para efetuar a compra',
          '#F97066',
          '../../../assets/Icons/ErrorIcon.png'
        );
        return;
      }
    }


    this.isLoading = true;

    const pendingOrdersRequest: PendingOrdersRequest = {
      Page: 0,
      PageSize: 1000,
      userId: this.loggedUser.userId,
      numClient: this.loggedUser.clientId,
      codigoMorada: this.selectedAddress.clientAddressCode
    };

    const dialogData = {
      title: ' com o Checkout?',
      description:
        ' com o Checkout? Pelo menos um destes items encontra-se numa encomenda pendente!',
      action: 'Continuar',
    };

    this.unsubscribe.add(
      this.encomendaService
        .getPendingOrders(pendingOrdersRequest)
        .subscribe(
          (resp) => {
            let normalProduct: PendingOrders[] = [];
            this.normalCurrencyCheckoutLines.forEach(
              (x) =>
                (normalProduct = resp.encomendas.data.filter(
                  (y) => y.codigo === x.referencia
                ))
            );

            let pointsProduct: PendingOrders[] = [];
            this.pointsProductCheckoutLines.forEach(
              (x) =>
                (pointsProduct = resp.encomendas.data.filter(
                  (y) => y.codigo === x.referencia
                ))
            );

            if (normalProduct.length > 0 || pointsProduct.length > 0) {
              const dialogRef = this.dialog.open(GenericModalComponent, {
                data: dialogData,
              });
              this.unsubscribe.add(
                dialogRef.afterClosed().subscribe((result) => {
                  if (result === true) {
                    this.ExecuteCheckout();
                  } else {
                    this.isLoading = false;
                  }
                })
              );
            } else {
              this.ExecuteCheckout();
            }
          },
          (error) => {
            console.error('Error fetching pending orders', error);
            this.isLoading = false;
            this.snackBarService.openSnackBar(
              'Erro ao verificar encomendas pendentes',
              '#F97066',
              '../../../assets/Icons/ErrorIcon.png'
            );
          }
        )
    );
  }

  // FUNCTION : Send the current data to Checkout
  async ExecuteCheckout(): Promise<void> {
    this.checkForDuplicateLines();
    if (this.duplicated === true) {
      const mensagem = `Não foi possível efetuar o checkout, produto duplicado no carrinho. Queira por favor remover a linha repetida e ajustar as quantidades em conformidade para a referência ${this.referenciaDuplicada}`;
      this.snackBarService.openSnackBar(
        mensagem,
        '#F97066',
        '../../../assets/Icons/ErrorIcon.png',
        15000
      );
      this.isLoading = false;
      return
    }
    let checkoutOrder: CheckoutOrderModel = {
      UserId: '',
      ClientId: this.profileRequest.clientId,
      Address: this.isMasterUser
        ? (this.selectedAddress?.clientAddressCode as string)
        : this.defaultAddress,
      Obs: this.observations,
      HasRecipe: false,
      Currency: 'EUR',
      OrderLines: this.normalCurrencyCheckoutLines.concat(
        this.pointsProductCheckoutLines
      ),
    };
    
    // Check if theres any labFlashDiscount or labFlashBonus in the order lines
    const hasLabFlashValues = checkoutOrder.OrderLines.some(
      (line) => (line.labFlashDiscount && line.labFlashDiscount > 0) || 
                (line.labFlashBonus && line.labFlashBonus > 0)
    );

    if (!hasLabFlashValues) {
    this.unsubscribe.add(
      this.checkoutService
        .ExecuteCheckout(checkoutOrder)
        .subscribe(async (response) => {
          let checkoutResponse: CheckoutOrderResponseModel[] = response;
          this.existsInDb = Number(checkoutResponse[0].dbOrderNumber) > 0;          
          // No responses returned
          if (checkoutResponse.length == 0) {
            this.snackBarService.openSnackBar(
              'Não foi possível efetuar o checkout, por favor tente mais tarde',
              '#F97066',
              '../../../assets/Icons/ErrorIcon.png'
            );
            this.isLoading = false;
          }

          // There are responses
          else {
            // For each entry, check if there is a success and register of what type of order it was
            let orderCount = 0;
            for (let i = 0; i < checkoutResponse.length; i++) {
              let element = checkoutResponse[i];
              if (element.sggSuccess || this.existsInDb) {
                this.anySuccess = true;
                if (element.orderOfPoints) this.pointsOrderSuccess = true;
                else this.regularOrderSuccess = true;

                if (orderCount == 0) {
                  this.sggOrderNumber = element.sggOrderNumber;
                  orderCount++;
                } else this.sggOrderNumber += ' / ' + element.sggOrderNumber;
              }
            }

            // if there was no success and Order DB Id equal to zero
            if (!this.anySuccess && !this.existsInDb) {
              this.snackBarService.openSnackBar(
                'Não foi possível efetuar o checkout, por favor tente mais tarde',
                '#F97066',
                '../../../assets/Icons/ErrorIcon.png'
              );
              this.isCheckoutComplete = false;
              this.isLoading = false;
            }
            // Check for all the possible success cases
            else {
              if (
                (response.length == 1 && this.regularOrderSuccess) ||
                (response.length == 1 && this.pointsOrderSuccess) ||
                (response.length == 2 &&
                  this.regularOrderSuccess &&
                  this.pointsOrderSuccess) ||
                (response.length > 0 && this.existsInDb)
              ) {
                this.snackBarService.openSnackBar(
                  'Pedido efetuado com sucesso',
                  '#12B76A',
                  '../../assets/Icons/correct.png'
                );
                this.isCheckoutComplete = true;
                this.isLoading = false;
                this.cartService.loadCart();

                let fullKey = this.user.userId + '_' + this.user.clientId + '_' + 'observations';
                sessionStorage.removeItem(fullKey);
                
                sessionStorage.removeItem('shopCart'); 
              }
              // This was a 2 part order and it only was partly successful
              else {
                this.snackBarService.openSnackBar(
                  'Pedido efetuado com sucesso de forma parcial. Tente fazer nova encomenda para os produtos que não foram encomendados.',
                  '#12B76A',
                  '../../assets/Icons/correct.png'
                );
                this.isCheckoutComplete = true;
                this.isLoading = false;
              }
            }
          }
        })
    );
    } else {
      this.unsubscribe.add(
      this.checkoutService
        .ExecuteCheckoutExcel(checkoutOrder)
        .subscribe(async (response) => {
          let checkoutResponse: CheckoutOrderResponseModel[] = response;
          // No responses returned
          if (checkoutResponse.length == 0) {
            this.snackBarService.openSnackBar(
              'Não foi possível efetuar o checkout, por favor tente mais tarde',
              '#F97066',
              '../../../assets/Icons/ErrorIcon.png'
            );
            this.isLoading = false;
          } 
          else {
            // For each entry, check if there is a success and register of what type of order it was
            for (let i = 0; i < checkoutResponse.length; i++) {
              let element = checkoutResponse[i];
              if (element.sggSuccess) {
                this.anySuccess = true;
                if (element.orderOfPoints) 
                  this.pointsOrderSuccess = true;
                else 
                  this.regularOrderSuccess = true;
              }
            }

            // if there was no success
            if (!this.anySuccess) {
              this.snackBarService.openSnackBar(
                'Não foi possível efetuar o checkout, por favor tente mais tarde',
                '#F97066',
                '../../../assets/Icons/ErrorIcon.png'
              );
              this.isCheckoutComplete = false;
              this.isLoading = false;
            }
            // Check for all the possible success cases
            else {
              if (
                (response.length == 1 && this.regularOrderSuccess) ||
                (response.length == 1 && this.pointsOrderSuccess) ||
                (response.length == 2 &&
                  this.regularOrderSuccess &&
                  this.pointsOrderSuccess)
                ) {
                this.snackBarService.openSnackBar(
                  'Pedido efetuado com sucesso',
                  '#12B76A',
                  '../../assets/Icons/correct.png'
                );
                this.isCheckoutComplete = true;
                this.isLoading = false;
                this.cartService.loadCart();

                let fullKey = this.user.userId + '_' + this.user.clientId + '_' + 'observations';
                sessionStorage.removeItem(fullKey);
                
                sessionStorage.removeItem('shopCart'); 
                this.cartService.clearSessionCart();
              }
              // This was a 2 part order and it only was partly successful
              else {
                this.snackBarService.openSnackBar(
                  'Pedido efetuado com sucesso de forma parcial. Tente fazer nova encomenda para os produtos que não foram encomendados.',
                  '#12B76A',
                  '../../assets/Icons/correct.png'
                );
                this.isCheckoutComplete = true;
                this.isLoading = false;
              }
            }
          }
        })
    );
    }

    localStorage.removeItem('BIO2_SelectedChangedAddress')
  }

  // FUNCTION : Checks all of the checkout lines and updates the order totals
  UpdateOrderTotals() {
    let total = 0;
    let pointsTotal = 0;
  
    this.normalCurrencyCheckoutLines.forEach((line) => {
      const finalUnitPrice = this.getFinalDiscountedPrice2(line);
      total += line.qtd * finalUnitPrice;
    });
  
    // ---------------------- PONTOS - ATUALIZAR -------------------->
    this.pointsProductCheckoutLines.forEach((line) => {
      pointsTotal += line.qtd * line.pontos;
    });
  
    this.orderTotal = parseFloat(total.toFixed(2));
    this.orderPointsTotal = pointsTotal;
  }
  
  // Add this variable to keep track of the current bonus index
  currentBonusIndex: number = 0;

  // FUNCTION : Checks if line has a bonus product and if it does, checks and updates the bonus quantity to receive
  CheckAndUpdateBonusQuantity(line: CheckoutLineModel): void {
    if (line.bonusProductInfo != null) {
      line.bonusProductInfo.forEach((bonusInfo) => {
        let productReference = line.referencia;
        let totalProductQuantity = 0;
        let bonusProductReference = bonusInfo.bonusProductReference;
        let totalBonusQuantity = 0;

        // Gets the total quantity of the product in normal currency
        this.normalCurrencyCheckoutLines.forEach((normalLine) => {
          if (normalLine.referencia == productReference)
            totalProductQuantity += normalLine.qtd;
        });

        // Gets the total quantity of the product in points
        this.pointsProductCheckoutLines.forEach((pointsLine) => {
          if (pointsLine.referencia == productReference)
            totalProductQuantity += pointsLine.qtd;
        });

        // Sort bonus tiers in descending order of requiredProductQuantity
        let sortedTiers = bonusInfo.bonusTiers.sort(
          (a, b) => b.requiredProductQuantity - a.requiredProductQuantity
        );

        let remainingQuantity = totalProductQuantity;

        // Iterate through bonus tiers and apply bonuses step by step
        sortedTiers.forEach((tier) => {
          let applicableBonusCount = Math.floor(
            remainingQuantity / tier.requiredProductQuantity
          );

          if (applicableBonusCount > 0) {
            totalBonusQuantity += applicableBonusCount * tier.bonusProductQuantityGiven;
            remainingQuantity -= applicableBonusCount * tier.requiredProductQuantity;
          }
        });

        // Update the accumulated bonus
        bonusInfo.bonusAccumulated = totalBonusQuantity;

        // If the bonus quantity is 0
        if (totalBonusQuantity == 0) {
          // Remove existing bonus product line if present
          let index = this.bonusProductCheckoutLines.findIndex(
            (x) => x.bonusProductReference == bonusProductReference
          );
          if (index != -1) this.bonusProductCheckoutLines.splice(index, 1);
        } else {
          // Find existing bonus product line
          let index = this.bonusProductCheckoutLines.findIndex(
            (x) => x.bonusProductReference == bonusProductReference
          );

          if (index != -1) {
            // Update the quantity
            this.bonusProductCheckoutLines[index].bonusAccumulated = totalBonusQuantity;
          } else {
            // Add new bonus product
            let bonusProductInfo: BonusProductInfo = {
              bonusProductReference: bonusProductReference,
              bonusProductName: bonusInfo.bonusProductName,
              bonusAccumulated: totalBonusQuantity,
              bonusTiers: bonusInfo.bonusTiers,
            };
            this.bonusProductCheckoutLines.push(bonusProductInfo);
            // Increment the currentBonusIndex when adding a new bonus product
            this.currentBonusIndex++;
          }
        }
      });
    }
  }

  // FUNCTION : Opens the modal to confirm the deletion of the line
  OpenDeleteConfirmationModal(checkoutLine: CheckoutLineModel) {
    this.checkoutLineToRemove = checkoutLine;
    const dialogRef = this.dialog.open(CheckoutDialogComponent, {
      width: '350px',
    });

    this.unsubscribe.add(
      dialogRef.afterClosed().subscribe((result: boolean) => {
        if (result) {
          this.RemoveLine(checkoutLine);
        }
      })
    );
  }

  onEnterPress(inputElement: HTMLInputElement): void {
    inputElement.blur();
  }

  OnkeyDown(e: any) {
    if (isNaN(e.key) && e.key !== 'Backspace' && e.key !== 'Enter') {
      e.preventDefault();
    }
  }


  getUserDetails(): void {
    this.perfilService
      .getUserProfileData(this.loggedUser.clientId, this.loggedUser.userId)
      .subscribe({
        next: (resp) => {
          this.userData = resp.client;
        },
        error: (e) => console.error(e),
      });
  }

  saveObservations() {
    // Save observations in DB
    const username = this.profileRequest.username;

    const clientId = this.user.role === 'SuperClient' || this.user.role === 'Cliente'
      ? undefined
      : this.user.clientId;

    this.unsubscribe.add(
      this.checkoutService
        .saveCheckoutObservation(username, this.observations, clientId)
        .subscribe({
          error: (err) => {
            console.error('Error saving user checkout observations:', err);
          },
        })
    );
  }

  fetchUserCheckoutObservation() {
    this.isLoading = true;

    if (this.user.role === 'SuperClient' || this.user.role === 'Cliente') {
      this.checkoutService.getUserCheckoutObservation(this.profileRequest.username).subscribe({
        next: (obs) => {
          this.observations = obs;
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Error fetching user checkout observation', err);
          this.isLoading = false;
        }
      });
    }
    else{
      this.checkoutService.getUserCheckoutObservation(this.profileRequest.username, this.user.clientId).subscribe({
        next: (obs) => {
          this.observations = obs;
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Error fetching user checkout observation', err);
          this.isLoading = false;
        }
      });
    }
  }

  isButtonDisabled(): boolean {
    if (this.orderPointsTotal === 0) {
      return false;
    }
    if (this.isReadingPoints || (this.orderPointsTotal > 0 && this.orderPointsTotal > this.points) || (this.orderTotal + this.orderPointsTotal) == 0) {
      return true;
    }
    else return false
  }

  onAddressSelect(event: any) {
    let newAddress = event.value
    this.encrypt.setEncryptedItem(
      StorageKeys.BIO2_SELECTED_CHANGED_ADDRESS,
      JSON.stringify(newAddress)
    );
  }

  isModalOpen: boolean = false;

  openModal() {
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }

  closeOuside(event: Event) {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      this.closeModal();
    }
  }

  getApplicableCampaign(line: { quantityCampaign?: QuantityCampaignDetails[]; qtd: number; labFlashDiscount?: number }): QuantityCampaignDetails | undefined {   
    // Lab Flash Discount 
    if(line.labFlashDiscount){
      const labFlashDiscountObj : QuantityCampaignDetails = {
        quantity: 0,
        discountPercentage: line.labFlashDiscount,
        discountedPrice: 0,
        maxQuantity: 999
      }
      return labFlashDiscountObj
    }
    // Campaign Discount 
    return line.quantityCampaign?.find(campaign => 
        line.qtd > campaign.quantity && 
        (campaign.maxQuantity === 0 || line.qtd <= campaign.maxQuantity) &&
        campaign.discountPercentage > 0 
    );
  }  
  
  getFormattedTotal(line: { qtd: number }): string {
    const finalUnitPrice = this.getFinalDiscountedPrice2(line);
    const total = finalUnitPrice * line.qtd;
    return total.toFixed(2);
  }
  
  getLabDiscountPrice(line: any): number {  
    if(!line.labFlashDiscount || line.labFlashDiscount == 0)
      return line.valor * (1 - (line.labDiscount ?? 0) / 100);
    else
      return line.valor
  }
  
  getCampaignDiscountPrice(line: any, campaign: any): number {
    const labPrice = this.getLabDiscountPrice(line);
    return labPrice * (1 - (campaign?.discountPercentage ?? 0) / 100);
  }
  
  getBio2DiscountPrice(line: any): number {
    const campaignPrice = this.getCampaignDiscountPrice(line, this.getApplicableCampaign(line));
    return campaignPrice * (1 - (line.discountPercentage ?? 0) / 100);
  }
  
  getFinalDiscountedPrice(line: any): number {
    const bio2Price = this.getBio2DiscountPrice(line);
    return bio2Price * (1 - (line.otherDiscount ?? 0) / 100);
  }  

  getFinalDiscountedPrice2(line: any): number {
    let price = line.valor;
  
    // Lab Flash Discount 
    if(line.labFlashDiscount){
      price *= (1 - (line.labFlashDiscount / 100));
    }
    else{
      // Apply Lab Discount
      if (line.labDiscount) {
        price *= (1 - (line.labDiscount / 100));
      }

      // Apply Campaign Discount
      const campaign = this.getApplicableCampaign(line);
      if (campaign?.discountPercentage) {
        price *= (1 - (campaign.discountPercentage / 100));
      }
    }
  
    // Apply Bio2 Discount
    if (line.discountPercentage) {
      price *= (1 - (line.discountPercentage / 100));
    }
  
    // Apply Other Discount
    if (line.otherDiscount) {
      price *= (1 - (line.otherDiscount / 100));
    }
  
    return price;
  }

  hasActiveQuantityCampaign(product: CheckoutLineModel): boolean {
    return product?.quantityCampaign?.some(campaign => 
      campaign.quantity >= 0 && campaign.discountPercentage > 0
    ) ?? false;
  }

  hasFlashDiscount(product: any): boolean{
    if(product.labFlashDiscount)
      return true;
    else
      return false;
  }

  openProductBonus(product: CheckoutLineModel): void {
    this.isCampaignModalOpen.emit(true);
    
    const convertedProduct: ShopItemModel = {
      reference: product.referencia,
      decription: product.memoria, 
      productImage: product.imagem,
      stock: product.stock,
      oldPrice: product.valor,
      currentPrice: product.valor_Liquido,
      class: '', // default
      group: '', // default
      atc: '', // default
      lab: '', // default
      points: 0, // default
      iva: '', // default
      family: '', // default
      subfamily: [], // default
      activeSubstance: [], // default
      species: '', // default
      situacao: '', // default
      bonus: product.bonusProductInfo.flatMap(b => 
        b.bonusTiers.map(t => ({
          referenceBonus: b.bonusProductReference,
          description: b.bonusProductName,
          bonus: `${t.requiredProductQuantity}+${t.bonusProductQuantityGiven}`,
          imageBonus: b.imageBonus ?? 'product_placeholder.png'
        }))
      ),
      favorite: false,// default
      imageId: '', // default
      productQuantity: product.qtd,
      isPoints: false,// default
      request: '',// default
      validate: new Date(), // default
      color: 0, // default
      files: '', // default
      discountPercentage: product.discountPercentage,
      labDiscount: product.labDiscount,
      otherDiscount: product.otherDiscount,
      quantityCampaign: product.quantityCampaign
    };

    var dataToSend: DialogData = {
      bonusData: convertedProduct,
      addButton: true,
      processChanges: true
    };
    const dialogRef = this.dialog.open(ProductBonusModalComponent, {
        data: dataToSend
    });
    
    this.unsubscribe.add(
      dialogRef.afterClosed().subscribe((result) => {
        this.isCampaignModalOpen.emit(false);
        if (result?.reference && result?.quantityToAdd) {
          this.updateProductQuantity(result.reference, result.quantityToAdd);
        }
      })
    );
  }

  updateProductQuantity(reference: string, quantityToAdd: number): void {
    let updated = false;
  
    // Try to find and update in normalCurrencyCheckoutLines
    for (let line of this.normalCurrencyCheckoutLines) {
      if (line.referencia === reference) {
        line.qtd += quantityToAdd;
        this.CheckAndUpdateBonusQuantity(line);
        updated = true;
        break;
      }
    }
  
    // If not found, try pointsProductCheckoutLines
    if (!updated) {
      for (let line of this.pointsProductCheckoutLines) {
        if (line.referencia === reference) {
          line.qtd += quantityToAdd;
          this.CheckAndUpdateBonusQuantity(line);
          break;
        }
      }
    }
  
    this.UpdateOrderTotals();
  }
  
  completeCampaigns() {
    // Filter to get only products with active campaigns and unmet lowest quantity required
    const campaignProducts = this.checkoutLines.filter(product => {
      
      const productQtd = product.qtd ?? 0;

      // Check if there's any bonus tier that the quantity doesn't meet (lowest tier only)
      const lowestBonusTierQty = product.bonusProductInfo
        ?.flatMap(bonus => bonus.bonusTiers ?? [])
        ?.map(tier => tier.requiredProductQuantity)
        ?.sort((a, b) => a - b)[0];

      const hasUnmetLowestBonusTier = lowestBonusTierQty !== undefined && productQtd < lowestBonusTierQty;

      // Check if there's any quantity campaign where the product doesn't meet the lowest required quantity
      const lowestCampaignQty = product.quantityCampaign
        ?.filter(campaign => campaign.quantity > 0)
        ?.map(campaign => campaign.quantity)
        ?.sort((a, b) => a - b)[0];

      const hasUnmetLowestQuantityCampaign = lowestCampaignQty !== undefined && productQtd <= lowestCampaignQty;

      return hasUnmetLowestBonusTier || hasUnmetLowestQuantityCampaign;
    });

    // If no campaign products, skip modal and go to next step
    if (campaignProducts.length === 0) {
      this.openModal(); // Open address modal
      return;
    }

    // Open dialog containing only eligible campaign products
    const dialogRef = this.dialog.open(CheckoutProductsCampaignsComponent, {
      maxWidth: '85vw',
      maxHeight: '90dvh',
      data: {
        products: campaignProducts.map(p => ({ ...p }))
      }
    });

    dialogRef.afterClosed().subscribe((result: { confirmed: boolean; products: CheckoutLineModel[] } | null | undefined) => {
      if(result?.confirmed){
        if (result.products.length > 0) {
          // Order confirmed and products quantity changed
          result.products.forEach(updated => {
            const target = this.checkoutLines.find(p => p.referencia === updated.referencia);
            if (target && updated.qtd !== target.qtd) {
              this.AddOrRemoveLineQuantity(target, 'update', updated.qtd.toString(),true);
            }
          });

          this.snackBarService.openSnackBar(
            'Quantidades atualizadas com sucesso!',
            '#0AA174',
            '../../assets/Icons/correct.png'
          );

          this.openModal(); // Open address modal
        } else {
          // Quantities remained unchanged
          this.openModal(); // Open address modal
        }
      }
    });
  }

  addDiscountQuantityClick(shopItem: CheckoutLineModel): void {
    const convertedProduct: ShopItemModel = {
      reference: shopItem.referencia,
      productQuantity: shopItem.qtd,
      points: shopItem.pontos,
      labFlashDiscount: shopItem.labFlashDiscount,
      labFlashBonus: shopItem.labFlashBonus,
      decription: '',
      stock: 0,
      oldPrice: 0,
      currentPrice: 0,
      class: '',
      group: '',
      atc: '',
      lab: '',
      iva: '',
      family: '',
      subfamily: [],
      activeSubstance: [],
      species: '',
      situacao: '',
      bonus: [],
      favorite: false,
      imageId: '',
      isPoints: false,
      validate: new Date(),
      color: 0,
      files: ''
    };

    const currentCart = this.cartService.getSessionCart()
    const currentCartProduct = currentCart.find((p: CartProductModel) => p.productId === convertedProduct.reference);
    if (currentCartProduct?.labFlashDiscount == 100){
      this.snackBarService.openSnackBar(
        'Desconto máximo atingido!',
        '#F97066',
        '../../../../assets/Icons/ErrorIcon.png'
      );
      return
    }

    this.unsubscribe.add(this.cartService.increaseDiscountQuantityCartMethod(convertedProduct));

    const savedCart = this.cartService.getSessionCart()
    const sessionCartProduct = savedCart.find((p: CartProductModel) => p.productId === convertedProduct.reference);
    if (sessionCartProduct) 
      shopItem.labFlashDiscount = sessionCartProduct.labFlashDiscount;


    // Update order total
    this.UpdateOrderTotals();
  }

  onDiscountFocus(event: FocusEvent, shopItem: CheckoutLineModel): void {
    const input = event.target as HTMLInputElement;
    input.dataset['prev'] = shopItem.labFlashDiscount?.toString() ?? "0";
  }
  
  changeDiscountQuantity(event: FocusEvent, shopItem: CheckoutLineModel): void {
    const convertedProduct: ShopItemModel = {
      reference: shopItem.referencia,
      productQuantity: shopItem.qtd,
      points: shopItem.pontos,
      labFlashDiscount: shopItem.labFlashDiscount,
      labFlashBonus: shopItem.labFlashBonus,
      decription: '',
      stock: 0,
      oldPrice: 0,
      currentPrice: 0,
      class: '',
      group: '',
      atc: '',
      lab: '',
      iva: '',
      family: '',
      subfamily: [],
      activeSubstance: [],
      species: '',
      situacao: '',
      bonus: [],
      favorite: false,
      imageId: '',
      isPoints: false,
      validate: new Date(),
      color: 0,
      files: ''
    };

    const input = event.target as HTMLInputElement;
    const numericValue = parseFloat(input.value.replace(',', '.'));
    const oldValue = Number(input.dataset['prev'] ?? 0);

    if (numericValue === oldValue || isNaN(numericValue) || numericValue < 0) {
      shopItem.labFlashDiscount = oldValue;
    } else {
      if (numericValue > 100){
        this.snackBarService.openSnackBar(
          'Desconto máximo ultrapassado!',
          '#F97066',
          '../../../../assets/Icons/ErrorIcon.png'
        );
        
        shopItem.labFlashDiscount = oldValue;
        return
      }
      this.unsubscribe.add(
        this.cartService.changeDiscountQuantityCartMethod(convertedProduct, numericValue)
      );
    }

    // update prev value for the next edit
    input.dataset['prev'] = shopItem.labFlashDiscount!.toString();


    // Update order total
    this.UpdateOrderTotals();
  }


  removeDiscountQuantityClick(shopItem: CheckoutLineModel): void { 
    const convertedProduct: ShopItemModel = {
      reference: shopItem.referencia,
      productQuantity: shopItem.qtd,
      points: shopItem.pontos,
      labFlashDiscount: shopItem.labFlashDiscount,
      labFlashBonus: shopItem.labFlashBonus,
      decription: '',
      stock: 0,
      oldPrice: 0,
      currentPrice: 0,
      class: '',
      group: '',
      atc: '',
      lab: '',
      iva: '',
      family: '',
      subfamily: [],
      activeSubstance: [],
      species: '',
      situacao: '',
      bonus: [],
      favorite: false,
      imageId: '',
      isPoints: false,
      validate: new Date(),
      color: 0,
      files: ''
    };

    this.unsubscribe.add(this.cartService.decreaseDiscountQuantityCartMethod(convertedProduct)); 
    
    const savedCart = this.cartService.getSessionCart()
    const sessionCartProduct = savedCart.find((p: CartProductModel) => p.productId === convertedProduct.reference);
    if (sessionCartProduct) 
      shopItem.labFlashDiscount = sessionCartProduct.labFlashDiscount;
    else
      shopItem.labFlashDiscount = 0


    // Update order total
    this.UpdateOrderTotals();
  }


  addBonusDiscountQuantityClick(shopItem: CheckoutLineModel): void {
    const convertedProduct: ShopItemModel = {
      reference: shopItem.referencia,
      productQuantity: shopItem.qtd,
      points: shopItem.pontos,
      labFlashDiscount: shopItem.labFlashDiscount,
      labFlashBonus: shopItem.labFlashBonus,
      decription: '',
      stock: 0,
      oldPrice: 0,
      currentPrice: 0,
      class: '',
      group: '',
      atc: '',
      lab: '',
      iva: '',
      family: '',
      subfamily: [],
      activeSubstance: [],
      species: '',
      situacao: '',
      bonus: [],
      favorite: false,
      imageId: '',
      isPoints: false,
      validate: new Date(),
      color: 0,
      files: ''
    };

    this.unsubscribe.add(this.cartService.increaseBonusQuantityCartMethod(convertedProduct));

    const savedCart = this.cartService.getSessionCart()
    const sessionCartProduct = savedCart.find((p: CartProductModel) => p.productId === convertedProduct.reference);
    if (sessionCartProduct) 
      shopItem.labFlashBonus = sessionCartProduct.labFlashBonus;

    const matchingLine = this.normalCurrencyCheckoutLines.find((line: CheckoutLineModel) => line.referencia === shopItem.referencia);
    if (matchingLine) {
      matchingLine.labFlashBonus = shopItem.labFlashBonus;
    }
  }

  onBonusFocus(event: FocusEvent, shopItem: CheckoutLineModel): void {
    const input = event.target as HTMLInputElement;
    input.dataset['prev'] = shopItem.labFlashBonus?.toString() ?? "0";
  }

  changeBonusQuantity(event: FocusEvent, shopItem: CheckoutLineModel): void {
    const convertedProduct: ShopItemModel = {
      reference: shopItem.referencia,
      productQuantity: shopItem.qtd,
      points: shopItem.pontos,
      labFlashDiscount: shopItem.labFlashDiscount,
      labFlashBonus: shopItem.labFlashBonus,
      decription: '',
      stock: 0,
      oldPrice: 0,
      currentPrice: 0,
      class: '',
      group: '',
      atc: '',
      lab: '',
      iva: '',
      family: '',
      subfamily: [],
      activeSubstance: [],
      species: '',
      situacao: '',
      bonus: [],
      favorite: false,
      imageId: '',
      isPoints: false,
      validate: new Date(),
      color: 0,
      files: ''
    };
    
    const input = event.target as HTMLInputElement;
    const numericValue = parseInt(input.value);
    const oldValue = Number(input.dataset['prev'] ?? 0);

    if (numericValue === oldValue || isNaN(numericValue) || numericValue < 0) {
      shopItem.labFlashBonus = oldValue;
    } else {
      this.unsubscribe.add(
        this.cartService.changeBonusQuantityCartMethod(convertedProduct, numericValue)
      );
    }

    // update prev value for the next edit
    input.dataset['prev'] = shopItem.labFlashDiscount!.toString();

    const matchingLine = this.normalCurrencyCheckoutLines.find((line: CheckoutLineModel) => line.referencia === shopItem.referencia);
    if (matchingLine) {
      matchingLine.labFlashBonus = shopItem.labFlashBonus;
    }
  }

  removeBonusQuantityClick(shopItem: CheckoutLineModel): void {
        const convertedProduct: ShopItemModel = {
      reference: shopItem.referencia,
      productQuantity: shopItem.qtd,
      points: shopItem.pontos,
      labFlashDiscount: shopItem.labFlashDiscount,
      labFlashBonus: shopItem.labFlashBonus,
      decription: '',
      stock: 0,
      oldPrice: 0,
      currentPrice: 0,
      class: '',
      group: '',
      atc: '',
      lab: '',
      iva: '',
      family: '',
      subfamily: [],
      activeSubstance: [],
      species: '',
      situacao: '',
      bonus: [],
      favorite: false,
      imageId: '',
      isPoints: false,
      validate: new Date(),
      color: 0,
      files: ''
    };

    this.unsubscribe.add(this.cartService.decreaseBonusQuantityCartMethod(convertedProduct)); 

    const savedCart = this.cartService.getSessionCart()
    const sessionCartProduct = savedCart.find((p: CartProductModel) => p.productId === convertedProduct.reference);
    if (sessionCartProduct) 
      shopItem.labFlashBonus = sessionCartProduct.labFlashBonus;
    else
      shopItem.labFlashBonus = 0

    const matchingLine = this.normalCurrencyCheckoutLines.find((line: CheckoutLineModel) => line.referencia === shopItem.referencia);
    if (matchingLine) {
      matchingLine.labFlashBonus = shopItem.labFlashBonus;
    }
  }

  isSubClient(){
    this.isLoading = true;
    this.unsubscribe.add(
      this.checkoutService
        .isSubClient(this.profileRequest.username)
        .subscribe({
          next: (resp) => {
            if(resp){
              this.hasSuperClient = true;
            }     
            this.isLoading = false
          },
          error: (err) => console.error('Error verifying if the user is sub client or not:', err),
          complete: () => (this.isLoading = false),
        })
    );
  }

  notifySuperClient(){
    this.isLoading = true;
    this.unsubscribe.add(
      this.checkoutService
        .notifySuperClient(this.profileRequest.username)
        .subscribe({
          next: (resp) => {
            if(resp){
              this.snackBarService.openSnackBar(
                'Notificação enviada com sucesso!',
                '#0AA174',
                '../../assets/Icons/correct.png'
              );
            }     
            this.isLoading = false
          },
          error: (err) => {
            this.snackBarService.openSnackBar(
              'Não foi possível enviar a notificação!',
              '#F97066',
              '../../../../assets/Icons/ErrorIcon.png'
            );
            console.error('Error sending cart notification to super client:', err)
          },
          complete: () => (this.isLoading = false),
        })
    );
  }

  ngOnDestroy(): void {
    this.unsubscribe.unsubscribe();
    if (this.pointsSubscription) {
      this.pointsSubscription.unsubscribe();
    }
  }
}
